import React from 'react'
import { EodDrawer, EodDrawerProvider } from '@nautilusjs/eod'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider } from '@maui/theme'
import { MatiSharedModals } from '@nautilusjs/mati-shared'
import env from '@maui-mf/env'
import { authenticatedFetch } from '@maui-mf/common-auth'
import { QueryClient, QueryClientProvider, useQuery, useMutation } from '@tanstack/react-query'

const queryClient = new QueryClient()

export const Root = () => (
  <BrowserRouter>
    <ThemeProvider theme="dark">
      <QueryClientProvider client={queryClient}>
        <EodDrawerProvider
          maApiHost={env.MAAPI_HOST}
          authenticatedFetch={authenticatedFetch}
          useQuery={useQuery}
          useMutation={useMutation}
        >
          <EodDrawer />
        </EodDrawerProvider>
      </QueryClientProvider>
      <MatiSharedModals />
    </ThemeProvider>
  </BrowserRouter>
)
